import { useSelector } from 'react-redux';
import Toggle from '../Toggle';
import { useNavigate } from 'react-router-dom';

export default function PikkoJackpotPrompt({ price, navigationPath }) {

    const { store } = useSelector((state) => state.store);
    const navigate = useNavigate();
    return(
        <div className='flex w-full items-center justify-between px-[0.8em] py-[0.7em] bg-[#F4EEFE] gap-[0.8em] rounded-[0.8em]'>
            <div className='flex items-center gap-[0.8em]'>
            <div className='jackpot-tag w-[5.2em] h-[3em]'>
                    <div className='flex w-full h-full object-cover bg-white rounded-[0.4em]'>
                        <img src={store.logo} alt="Logo Magasin" />
                    </div>
                </div>

                <p className='geomanistBook text-[14px] text-[#8130EC]'>
                    Récupère
                    <span className='text-[#944FEF] geomanistMedium text-[18px] text-center'> {price} </span>
                    cagnotte
                </p>
            </div>

            <Toggle checked={false} onChange={() => navigate(navigationPath)} />

        </div>
    )
}
